<template>
  <v-container fluid>
    <v-row no-gutters class="d-flex justify-space-between mt-5 mb-1">
      <h1 class="page-title">Mapping QA - Regional</h1>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <p class="label-text-field" color="primary">Cari</p>
        <v-text-field label="" class="rp mb-0" hide-details="auto" v-model="searchValue" outlined placeholder="Cari..."
          dense prepend-inner-icon="mdi-magnify"></v-text-field>
      </v-col>

      <v-col>
        <p class="transparent--text" color="primary"></p>
        <v-row>
          <v-btn @click="search" class="elevation-0 text-capitalize ml-3 mt-2" cols="12" color="primary">
            <span class="white--text">Cari</span></v-btn>
          <v-btn class="elevation-0 text-capitalize ml-3 mt-2 primary--text" depressed outlined color="primary"
            cols="12" @click="reset">
            <span class="orange--text">Reset</span></v-btn>
        </v-row>
      </v-col>
      <v-col class="text-right">
        <p class="transparent--text" color="primary"></p>
        <v-btn class="elevation-0 mt-2" color="primary" @click="addMapping()">
          <v-icon left>
            mdi-plus
          </v-icon>
          Tambah
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="18">
        <div class="pf">
          <v-card>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-data-table mobile-breakpoint="0" :headers="headers" :items="qaMappingList" :items-per-page="5" :server-items-length="totalData"
                    :header-props="{ sortIcon: null }" @update:options="updateTableOptions" disable-sort>
                    <template v-slot:item="data">
                      <tr>
                        <td>{{ data.item.karyawanNik }}</td>
                        <td>{{ data.item.karyawanName }}</td>
                        <td>{{ data.item.region }}</td>
                        <td align="center">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn small text class="text-capitalize black--text px-0" v-on="on" v-bind="attrs"
                                @click="editMapping(data.item.mappingId)">
                                <v-icon aria-hidden="false" style="font-size: 20px" color="#F5821F">
                                  mdi-square-edit-outline
                                </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit</span>
                          </v-tooltip>
                          <v-dialog v-model="dialogDel[data.item.mappingId]" persistent :key="data.item.mappingId"
                            width="unset">
                            <template v-slot:activator="{ on: dialog, attrs }">
                              <v-tooltip bottom slot="activator">
                                <template v-slot:activator="{ on: tooltip }">
                                  <v-btn small text class="text-capitalize black--text px-0"
                                    v-on="{ ...dialog, ...tooltip }" v-bind="attrs">
                                    <v-icon aria-hidden="false" style="font-size: 18px" color="#F5821F">
                                      mdi-delete-outline
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <span>Delete</span>
                              </v-tooltip>
                            </template>
                            <div class="dialogDelete text-center">
                              <v-sheet>
                                <v-icon class="icon" @click="
                                  dialogDel[
                                  data.item.mappingId
                                  ] = false
                                " style="float: right">mdi-close</v-icon>
                                <img src="@/assets/Warning.svg" alt="" />
                                <div class="pDialog">
                                  Hapus Mapping ?
                                  <p>
                                    {{ data.item.karyawanNik }}
                                  </p>
                                </div>
                                <v-btn class="paramDialogBtn ma-1" color="primary" text @click="
                                  $set(dialogDel, data.item.mappingId, false)
                                ">Batalkan</v-btn>
                                <v-btn class="paramDialogDelBtn ma-1" color="primary" text @click="
                                  deleteMapping(data.item.mappingId),
                                  $set(dialogDel, data.item.mappingId, false)
                                ">Hapus</v-btn>
                              </v-sheet>
                            </div>
                          </v-dialog>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      page: 1,
      itemsPerPage: 5,
      totalData: null,
      countData: null,
      qaMappingList: [],
      dialogDel: {},
      headers: [
        {
          text: "NIK",
          align: "center",
          width: "140px",
        },
        {
          text: "Nama",
          align: "center",
          width: "150px",
        },
        {
          text: "Regional",
          align: "center",
          width: "150px",
        },
        {
          text: "Tindakan",
          align: "center",
          width: "150px",
        },
      ],
    };
  },
  async mounted() {
    
  },
  created() {
    this.requiredFeature('QA_MAPPING')
    this.changeTitleApp("Mapping QA - Regional");
  },
  methods: {
    ...mapActions([
      "changeTitleApp", 
      "searchQARegionalMapping",
      "deleteQARegionalMapping"
    ]),

    reset: function () {
      this.searchValue = "";
      this.search();
    },

    search() {
      let page = this.page;
      let itemsPerPage = this.itemsPerPage;
      let searchValue = this.searchValue;

      this.searchQARegionalMapping({
        searchValue: searchValue,
        page: page,
        itemsPerPage: itemsPerPage,
      }).then((response) => {
        this.qaMappingList = response.data.data;
        this.totalData = response.data.countData;
      }).catch((err) => {
        this.qaMappingList = [];
        this.$helpers.handleError(err);
      });
    },
    deleteMapping(id) {
      this.loading = true;

      this.deleteQARegionalMapping({
        id: id,
      }).then((response) => {
        this.$helpers.handleSuccess(response);

        this.search();
      }).catch((err) => {
        this.$helpers.handleError(err);
      }).finally(() => {
        this.loading = false;
      });
    },
    addMapping() {
      this.$router.push({
        name: "QAMappingForm",
        params: { mode: "add" },
      });
    },
    editMapping(id) {
      this.$router.push({
        name: "QAMappingForm",
        params: { mode: "edit", id: id },
      });
    },
    updateTableOptions(options) {
      this.page = options.page
      this.itemsPerPage = options.itemsPerPage

      this.search();
    },
  },
};
</script>
<style src="./QAMapping.scss" lang="scss" />